import { render, staticRenderFns } from "./DetalleDesacumulados.vue?vue&type=template&id=40676bdc&scoped=true"
import script from "./DetalleDesacumulados.vue?vue&type=script&lang=js"
export * from "./DetalleDesacumulados.vue?vue&type=script&lang=js"
import style0 from "./DetalleDesacumulados.vue?vue&type=style&index=0&id=40676bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40676bdc",
  null
  
)

export default component.exports